import { Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Img1 from "./termConditionImg/term1.jpeg";
import Img2 from "./termConditionImg/term2.jpeg";
import Img3 from "./termConditionImg/term3.jpeg";
import { List, ListItem, ListItemText } from "@mui/material";
import CertificateCard from "../CertificateCard/CertificateCard";
import { useLocation } from "react-router-dom";

const TermCondition = () => {
  const location = useLocation();
  const { termCondition1, privacyPolicy1, refundPloicy1 } =
    location.state || {};
  const { parameter } = location.state || {};
  const [termCondition, setTermCondition] = useState(termCondition1);
  const [privacyPolicy, setPrivacyPolicy] = useState(privacyPolicy1);
  const [refundPloicy, setRefundPolicy] = useState(refundPloicy1);
  const [titleName, setTitleName] = useState("Title");
  const [breadcrunmbs, setBreadcrunmbs] = useState("BreadCrumbs");
  console.log("parameter:==========>>>", parameter);
  // Scroll to top when the component is mounted
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const policyArray = [
    {
      name: "Term and condition",
      title: "1",
      breadcrumbs: "term and condition",
    },
    {
      name: "Privacy Policy",
      title: "2",
      breadcrumbs: "privacy policy",
    },
    {
      name: "Refund Policy",
      title: "3",
      breadcrumbs: "refund policy",
    },
  ];

  const handleTernCondition = () => {
    setTitleName(policyArray[0]?.name);
    setBreadcrunmbs(policyArray[0]?.breadcrumbs);
    setPrivacyPolicy("false");
    setRefundPolicy("false");
    setTermCondition("true");
    console.log("value:", policyArray[0]?.name);
  };
  const handlePrivacyPolicy = () => {
    setTitleName(policyArray[1]?.name);
    setBreadcrunmbs(policyArray[1]?.breadcrumbs);
    setRefundPolicy("false");
    setTermCondition("false");
    setPrivacyPolicy("true");
    console.log("value:", policyArray[1]?.name);
  };
  const handleRefundPolicy = () => {
    setTitleName(policyArray[2]?.name);
    setBreadcrunmbs(policyArray[2]?.breadcrumbs);
    setTermCondition("false");
    setPrivacyPolicy("false");
    setRefundPolicy("true");
    console.log("value:", policyArray[2]?.name);
  };

  useEffect(() => {
    if (termCondition1 || parameter === "1") {
      setTitleName(policyArray[0]?.name);
      setBreadcrunmbs(policyArray[0]?.breadcrumbs);
    } else if (privacyPolicy1 || parameter === "2") {
      setTitleName(policyArray[1]?.name);
      setBreadcrunmbs(policyArray[1]?.breadcrumbs);
    } else {
      setTitleName(policyArray[2]?.name);
      setBreadcrunmbs(policyArray[2]?.breadcrumbs);
    }
  }, [termCondition1, privacyPolicy1, refundPloicy1, parameter]);

  return (
    <>
      <Header />
      <main>
        <Stack
          sx={{
            height: "auto",
            display: "flex",
            flexDirection: { xl: "row" },
            justifyContent: "center",
            // border: "1px solid blue",
          }}
        >
          <Stack
            sx={{
              // border: "1px solid red",
              width: { xl: "70%" },
              marginBottom: "60px",
            }}
          >
            {/* Header Section */}

            <Stack
              sx={{
                // border: "1px solid blue",
                marginTop: "20px",
                height: { xl: "14%" },
                dispaly: "flex",
                flexDirection: { xl: "column" },
              }}
            >
              <Stack
                sx={{
                  // border: "2px solid red",
                  height: { xl: "60%" },
                  dispaly: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xl: "40px" },
                    fontFamily:
                      "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    fontWeight: 600,
                  }}
                >
                  {titleName}
                </Typography>
              </Stack>
              <Stack
                sx={{
                  dispaly: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  // border: "1px solid red",
                }}
              >
                <Stack
                  sx={{
                    dispaly: "flex",
                    flexDirection: {
                      xl: "row",
                      lg: "row",
                      md: "row",
                      sm: "row",
                      xs: "column",
                    },
                    alignItems: "center",
                    justifyContent: "space-between",
                    // border: "2px solid red",
                    width: {
                      xl: "40%",
                      lg: "50%",
                      md: "50%",
                      sm: "50%",
                      xs: "100%",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { xl: "12px" },
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      fontWeight: 400,
                    }}
                  >
                    Effective Date: August 3rd, 2021
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: { xl: "12px" },
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      fontWeight: 400,
                    }}
                  >
                    Last Updated on: January 1st, 2025
                  </Typography>
                </Stack>
              </Stack>
              <Stack
                sx={{
                  // border: "2px solid blue",
                  height: { xl: "30%" },
                  dispaly: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Breadcrumbs
                  aria-label="breadcrumb"
                  sx={{ marginLeft: "12px" }}
                >
                  <Link
                    underline="hover"
                    color="inherit"
                    href="/"
                    sx={{
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      fontWeight: 600,
                    }}
                  >
                    Home
                  </Link>
                  <Link
                    underline="none"
                    color="inherit"
                    sx={{
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                    }}
                  >
                    {breadcrunmbs}
                  </Link>
                </Breadcrumbs>
              </Stack>
            </Stack>

            {/* Cotent Section */}

            <Stack
              sx={{
                // border: "3px solid green",
                marginTop: "60px",
                dispaly: "flex",
                flexDirection: {
                  xl: "row",
                  lg: "row",
                  md: "row",
                  sm: "row",
                  xs: "column",
                },
                justifyContent: "space-between",
              }}
            >
              <Stack
                sx={{
                  width: { xl: "70%", lg: "70%", md: "70%", sm: "70%" },
                  // border: "1px solid blue",
                  border: "1px solid #d1d1d1",
                  borderRadius: "8px",
                  padding: "16px",
                  backgroundColor: "#fff",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                  color: "#333",
                  lineHeight: "1.6",
                  fontFamily: "Arial, sans-serif",
                  fontSize: "14px",
                  overflow: "hidden",
                }}
              >
                {termCondition === "true" && (
                  <>
                    {/* 1st */}
                    <h1
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                        marginBottom: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Agreement
                    </h1>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      By accessing or using http://www.vertexsuite.com you
                      represent that you have the full authority to act to bind
                      yourself, any third party, company, or legal entityand
                      that your use and/or interaction, as well as continuing to
                      use or interact, with the website constitutes your having
                      read and agreed to these terms of use as well as other
                      agreements that we may post on the website. By viewing,
                      visiting, using, or interacting with this website or with
                      any banner, pop-up, or advertising that appears on it, you
                      are agreeing to all the provisions of this terms of use
                      policy as well as the privacy policy of this website. This
                      website specifically denies access to any individual that
                      is covered by the children's online privacy protection act
                      (coppa) of 1998. This site reserves the right to deny
                      access to any person or viewer for any lawful reason.
                      under the terms of the privacy policy, which you accept as
                      a condition for viewing, this website is allowed to
                      collect and store data and information for the purpose of
                      exclusion and for many other uses. This terms of use
                      agreement may change from time to time. Visitors have an
                      affirmative duty, as part of the consideration for
                      permission to access this website, to keep themselves
                      informed of such changes by reviewing this terms of use
                      page each time they visit this website.
                    </p>
                    {/* 2nd */}

                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Personally Identifiable Information
                    </h2>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Refers to any information that identifies or can be used
                      to identify, contact, or locate the person to whom such
                      information pertains, including, but not limited to, name,
                      address, phone number, email address, IP address, location
                      and browser . Personally Identifiable Information does not
                      include information that is collected anonymously (that
                      is, without identification of the individual user) or
                      demographic information not connected to an identified
                      individual.
                    </p>
                    {/* 3rd */}
                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Parties to the terms of use agreement
                    </h2>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Visitors, viewers, users, subscribers, members,
                      affiliates, or customers, collectively referred to herein
                      as “Visitors,” are parties to this agreement. The website
                      and its owners and/or operators are parties to this
                      agreement, herein referred to as “Website.”
                    </p>
                    {/* 4st */}
                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Hyperlinking to site, co-branding, “framing” and
                      referencing website prohibited
                    </h2>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Unless expressly authorized by website, no one may
                      hyperlink this website, or portions thereof, (including,
                      but not limited to, logotypes, trademarks, branding or
                      copyrighted material) to theirs for any reason.
                      Furthermore, you are not permitted to reference the URL
                      (website address) of this website or any page of this
                      website in any commercial or non-commercial media without
                      express permission from us, nor are you allowed to 'frame'
                      the website. You specifically agree to cooperate with the
                      website to remove or de-activate any such activitiesand
                      be liable for all damages arising from violating this
                      provision. In recognition of the fact that it may be
                      difficult to quantify the exact damages arising from
                      infringement of this provision, you agree to compensate
                      the owners of this website with liquidated damages, the
                      actual costs and actual damages for breach of this
                      provision, whichever is greater. You warrant that you
                      understand that accepting this provision is a condition of
                      accessing this website and that accessing this website
                      constitutes acceptance.
                    </p>
                    {/* 5st */}
                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Disclaimer for contents of website
                    </h2>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      The website disclaims any responsibility for the accuracy
                      of the content appearing at, linked to on, or mentioned on
                      this website. Visitors assume all risk relating to
                      viewing, reading, using, or relying upon this information.
                      Unless you have otherwise formed an express contract to
                      the contrary with us, you have no right to rely on any
                      information contained herein as accurate. We make no such
                      warranty. We assume no responsibility for damage to
                      computers or software of the visitor or any person the
                      visitor subsequently communicates with from corrupting
                      code or data that is inadvertently passed to the visitor’s
                      computer. Again, visitor views and interacts with this
                      website, or banners or pop-ups or advertising displayed
                      thereon, at his own risk.
                    </p>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      This website is not part of the Facebook website or
                      Facebook Inc. Additionally, this site is not endorsed by
                      Facebook in any way. Facebook is a trademark of Facebook,
                      Inc. We use Google remarketing pixels/cookies on this site
                      to re-communicate with people who visit our site and
                      ensure that we are able to reach them in the future with
                      relevant messages and information. Google shows our ads
                      across third party sites across the internet to help
                      communicate our message and reach the right people who
                      have shown interest in our information in the past.
                    </p>

                    {/* 6st */}
                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Indemnification
                    </h2>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Visitor agrees that in the event he causes damage to us or
                      a third party as a result of or relating to the use of
                      this website, visitor will indemnify us forand, if
                      applicable, defend us against, any claims for damages.
                    </p>
                    {/* 7st */}
                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Submissions
                    </h2>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Visitor agrees as a condition of viewing, that any
                      communication between visitor and Website is deemed a
                      submission. All submissions, including portions thereof,
                      graphics contained thereon, or any of the content of the
                      submission, shall become the exclusive property of the
                      Website and may be used, without further permission, for
                      commercial use without additional consideration of any
                      kind. Visitor agrees to only communicate that information
                      to the Website, which it wishes to forever allow the
                      Website to use in any manner as it sees fit. “Submissions”
                      is also a provision of the privacy policy.
                    </p>
                    {/* 8st */}
                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      User registration
                    </h2>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      You may be required to register with the Site. You agree
                      to keep your password confidential and will be responsible
                      for all use of your account and password. We reserve the
                      right to remove, reclaim, or change a username you select
                      if we determine, in our sole discretion, that such
                      username is inappropriate, obscene, or otherwise
                      objectionable.
                    </p>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      By using the Site, you represent and warrant that: (1) all
                      registration information you submit will be true,
                      accurate, currentand complete; (2) you will maintain the
                      accuracy of such information and promptly update such
                      registration information as necessary; (3) you have the
                      legal capacity and you agree to comply with these Terms;
                      (4) you are not a minor in the jurisdiction in which you
                      reside; (5) you will not access the Site through automated
                      or non-human means, whether through a bot, script or
                      otherwise; (6) you will not use the Site for any illegal
                      or unauthorized purpose; and (7) your use of the Site will
                      not violate any applicable law or regulation. If you
                      provide any information that is untrue, inaccurate, not
                      current, or incomplete, we have the right to suspend or
                      terminate your account and refuse any and all current or
                      future use of the Site (or any portion thereof).
                    </p>
                    {/* 9st */}
                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Intellectual property rights
                    </h2>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Unless otherwise indicated, the Site is our proprietary
                      property and all source code, databases, functionality,
                      software, website designs, audio, video, text,
                      photographsand graphics on the Site (collectively, the
                      “Content”) and the trademarks, service marksand logos
                      contained therein (the “Marks”) are owned or controlled by
                      us or licensed to usand are protected by copyright and
                      trademark laws and various other intellectual property
                      rights and unfair competition laws of the United States,
                      foreign jurisdictionsand international conventions. The
                      Content and the Marks are provided on the Site “AS IS” for
                      your information and personal use only. Except as
                      expressly provided in these Terms, no part of the Site and
                      no Content or Marks may be copied, reproduced, aggregated,
                      republished, uploaded, posted, publicly displayed,
                      encoded, translated, transmitted, distributed, sold,
                      licensed, or otherwise exploited for any commercial
                      purpose whatsoever, without our express prior written
                      permission. Provided that you are eligible to use the
                      Site, you are granted a limited license to access and use
                      the Site and to download or print a copy of any portion of
                      the Content to which you have properly gained access
                      solely for your personal, non-commercial use. We reserve
                      all rights not expressly granted to you in and to the
                      Site, the Content and the Marks.
                    </p>
                    {/* 10st */}
                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Site management
                    </h2>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      We reserve the right, but not the obligation, to: (1)
                      monitor the Site for violations of these Terms; (2) take
                      appropriate legal action against anyone who, in our sole
                      discretion, violates the law or these Terms, including
                      without limitation, reporting such user to law enforcement
                      authorities; (3) in our sole discretion and without
                      limitation, refuse, restrict access to, limit the
                      availability of, or disable (to the extent technologically
                      feasible) any of your Contributions or any portion
                      thereof; (4) in our sole discretion and without
                      limitation, notice, or liability, to remove from the Site
                      or otherwise disable all files and content that are
                      excessive in size or are in any way burdensome to our
                      systems; and (5) otherwise manage the Site in a manner
                      designed to protect our rights and property and to
                      facilitate the proper functioning of the Site.
                    </p>

                    {/* 11st */}
                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Term and termination
                    </h2>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      These Terms shall remain in full force and effect while
                      you use the Site. Without limiting any other provision of
                      these terms, we reserve the right to, in our sole
                      discretion and without notice or liability, deny access to
                      and use of the site (including blocking certain IP
                      addresses), to any person for any reason or for no reason,
                      including without limitation for breach of any
                      representation, warranty, or covenant contained in these
                      terms or any applicable law of regulation. We may
                      terminate your use or participation in the site or delete
                      your account and any content or information that you
                      posted at any time, without warning, in our sole
                      discretion. If we terminate or suspend your account for
                      any reason, you are prohibited from registering and
                      creating a new account under your name, a fake or borrowed
                      name, or the name of any third party, even if you may be
                      acting on behalf of the third party. In addition to
                      terminating or suspending your account, we reserve the
                      right to take appropriate legal action, including without
                      limitation pursuing civil, criminaland injunctive
                      redress.
                    </p>
                    {/* 12th */}
                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Notice
                    </h2>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      No additional notice of any kind for any reason is
                      required to be given to visitor and visitor expressly
                      warrants an understanding that the right to notice is
                      waived as a condition for permission to view or interact
                      with the website.
                    </p>
                  </>
                )}
                {privacyPolicy === "true" && (
                  <>
                    {" "}
                    {/* 1st */}
                    <h1
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                        marginBottom: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Introduction
                    </h1>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Welcome to Vertex Suite. We understand that privacy online
                      is important to users of our Site, especially when
                      conducting business. This statement governs our privacy
                      policies with respect to those users of the Site
                      (`Visitors`) who visit without transacting business and
                      Visitors who register to transact business on the Site and
                      make use of the various services offered by this site
                      (collectively, `Services`) (`Authorized Customers`).
                    </p>
                    {/* 2nd */}
                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Personally Identifiable Information
                    </h2>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Refers to any information that identifies or can be used
                      to identify, contact, or locate the person to whom such
                      information pertains, including, but not limited to, name,
                      address, phone number, email address, IP address, location
                      and browser. Personally Identifiable Information does not
                      include information that is collected anonymously (that
                      is, without identification of the individual user) or
                      demographic information not connected to an identified
                      individual.
                    </p>
                    {/* 3rd */}
                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      What Personally Identifiable Information is collected?
                    </h2>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      We may collect basic user profile information from all of
                      our Visitors. We collect the following additional
                      information from our Authorized Customers: the name,
                      address, phone number, email address, IP address, location
                      and browser of Authorized Customers, the nature and size
                      of the businessand the nature and size of the
                      advertising inventory that the Authorized Customer intends
                      to purchase.
                    </p>
                    {/* 4st */}
                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      What organizations are collecting the information?
                    </h2>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      In addition to our direct collection of information, our
                      third party service vendors (such as credit card
                      companies, clearinghouses and banks) who may provide such
                      services as credit, insuranceand escrow services may
                      collect this information from our Visitors and Authorized
                      Customers. We do not control how these third parties use
                      such information, but we do ask them to disclose how they
                      use personal information provided to them from Visitors
                      and Authorized Customers. Some of these third parties may
                      be intermediaries that act solely as links in the
                      distribution chainand do not store, retain, or use the
                      information given to them.
                    </p>
                    {/* 5st */}
                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      How does the Site use Personally Identifiable Information?
                    </h2>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Use Personally Identifiable Information to customize the
                      Site, to make appropriate service offeringsand to fulfil
                      buying and selling requests on the Site. We may email
                      Visitors and Authorized Customers about research or
                      purchase and selling opportunities on the Site or
                      information related to the subject matter of the Site. We
                      may also use Personally Identifiable Information to
                      contact Visitors and Authorized Customers in response to
                      specific inquiries, or to provide requested information.
                    </p>
                    {/* 6st */}
                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      With whom the information may be shared?
                    </h2>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Personally Identifiable Information about Authorized
                      Customers may be shared with other Authorized Customers
                      who wish to evaluate potential transactions with other
                      Authorized Customers. We may share aggregated information
                      about our Visitors, including the demographics of our
                      Visitors and Authorized Customers, with third party
                      vendors.
                    </p>
                    {/* 7st */}
                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      How is Personally Identifiable Information stored?
                    </h2>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Personally Identifiable Information collected by This APP
                      is securely stored and is not accessible to third parties
                      or employees of This APP except for use as indicated
                      above.
                    </p>
                    {/* 8st */}
                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      What choices are available to Visitors regarding
                      collection, use and distribution of the information?
                    </h2>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Visitors and Authorized Customers may opt out of receiving
                      unsolicited information from or being contacted by us
                      and/or our vendors and affiliated agencies by responding
                      to emails as instructed, or by contacting us.
                    </p>
                    {/* 9st */}
                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Are Cookies Used on the Site?
                    </h2>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Cookies are used for a variety of reasons. We use Cookies
                      to obtain information about the preferences of our
                      Visitors and the services they select. We also use Cookies
                      for security purposes to protect our Authorized Customers.
                      For example, if an Authorized Customer is logged on and
                      the site is unused, we will automatically log the
                      Authorized Customer off.
                    </p>
                    {/* 10st */}
                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      How does the Site keep Personally Identifiable Information
                      secure?
                    </h2>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      All of our employees are familiar with our security policy
                      and practices. The Personally Identifiable Information of
                      our Visitors and Authorized Customers is only accessible
                      to a limited number of qualified employees who are given a
                      password in order to gain access to the information. We
                      audit our security systems and processes on a regular
                      basis. Sensitive information, such as credit card numbers
                      or social security numbers, is protected by encryption
                      protocols, in place to protect information sent over the
                      Internet and we do not store them. While we take
                      commercially reasonable measures to maintain a secure
                      site, electronic communications and databases are subject
                      to errors, tampering and break-insand we cannot
                      guarantee or warrant that such events will not take place
                      and we will not be liable to Visitors or Authorized
                      Customers for any such occurrences.
                    </p>
                    {/* 11st */}
                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      How can Visitors correct any inaccuracies in Personally
                      Identifiable Information?
                    </h2>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Visitors and Authorized Customers may contact us to update
                      Personally Identifiable Information about them or to
                      correct any inaccuracies by emailing us.
                    </p>
                    {/* 12th */}
                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Can a Visitor delete or deactivate Personally Identifiable
                      Information collected by the Site?
                    </h2>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      We provide Visitors and Authorized Customers with a
                      mechanism to delete/deactivate Personally Identifiable
                      Information from the Site`s database by contacting.
                      However, because of backups and records of deletions, it
                      may be impossible to delete a Visitor`s entry without
                      retaining some residual information. An individual who
                      requests to have Personally Identifiable Information
                      deactivated will have this information functionally
                      deletedand we will not sell, transfer, or use Personally
                      Identifiable Information relating to that individual in
                      any way moving forward.
                    </p>
                    {/* 13th */}
                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      What happens if the Privacy Policy Changes?
                    </h2>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      We will let our Visitors and Authorized Customers know
                      about changes to our privacy policy by posting such
                      changes on the Site. However, if we are changing our
                      privacy policy in a manner that might cause disclosure of
                      Personally Identifiable Information that a Visitor or
                      Authorized Customer has previously requested not be
                      disclosed, we will contact such Visitor or Authorized
                      Customer to allow such Visitor or Authorized Customer to
                      prevent such disclosure.
                    </p>
                    {/* 14th */}
                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginTop: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Links
                    </h2>
                    <p
                      style={{
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      http://www.vertexsuite.com contains links to other web
                      sites. Please note that when you click on one of these
                      links, you are moving to another web site. We encourage
                      you to read the privacy statements of these linked sites
                      as their privacy policies may differ from ours.
                    </p>
                  </>
                )}
                {refundPloicy === "true" && (
                  <>
                    <p
                      style={{
                        marginBottom: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      At Vertex Suite, we are committed to providing you with
                      exceptional SaaS solutions, ensuring your experience is
                      seamless and satisfactory. Our refund policy is designed
                      to be transparent, fairand customer-centric. Please take
                      a moment to read and understand our policy.
                    </p>

                    {/* Section 1 */}
                    <h2
                      style={{
                        fontWeight: "bold",
                        fontSize: "24px",
                        marginBottom: "8px",
                        color: "#000",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Customer Satisfaction is Our Priority
                    </h2>
                    <hr
                      style={{
                        border: "1px solid #ddd",
                        marginBottom: "8px",
                      }}
                    />
                    <p
                      style={{
                        marginBottom: "24px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      We value your trust in our services. If you find yourself
                      dissatisfied within the first 7 days of your subscription,
                      we are here to address your concerns.
                    </p>

                    {/* Section 2 */}
                    <h2
                      style={{
                        fontWeight: "bold",
                        fontSize: "24px",
                        marginBottom: "8px",
                        color: "#000",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Eligibility Criteria for Refund
                    </h2>
                    <hr
                      style={{
                        border: "1px solid #ddd",
                        marginBottom: "8px",
                      }}
                    />
                    <p
                      style={{
                        marginBottom: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      To be eligible for a refund, please ensure:
                    </p>
                    <ul style={{ marginLeft: "20px", marginBottom: "24px" }}>
                      <li
                        style={{
                          marginBottom: "8px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        Refund requests are made within 7 days of your initial
                        subscription.
                      </li>
                      <li
                        style={{
                          marginBottom: "8px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        The reason for the refund is directly related to the
                        performance or functionality of our platform.
                      </li>
                    </ul>

                    {/* Section 3 */}
                    <h2
                      style={{
                        fontWeight: "bold",
                        fontSize: "24px",
                        marginBottom: "8px",
                        color: "#000",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Refund Request Process
                    </h2>
                    <hr
                      style={{
                        border: "1px solid #ddd",
                        marginBottom: "8px",
                      }}
                    />
                    <p
                      style={{
                        marginBottom: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Although we aim to help our customers as much as possible,
                      there are cases where we can't offer refunds:
                    </p>
                    <ul style={{ marginLeft: "20px" }}>
                      <li
                        style={{
                          marginBottom: "8px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        In the event that the refund request is submitted beyond
                        the 30-day window.
                      </li>
                      <li
                        style={{
                          marginBottom: "8px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        If the concerns expressed fall outside the purview of
                        what our SaaS platform can do.
                      </li>
                      <li
                        style={{
                          marginBottom: "8px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        Should our terms of service be broken.
                      </li>
                    </ul>

                    {/* Section 4 */}
                    <h2
                      style={{
                        fontWeight: "bold",
                        fontSize: "24px",
                        marginBottom: "8px",
                        color: "#000",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Exceptions to Refund Policy
                    </h2>
                    <hr
                      style={{
                        border: "1px solid #ddd",
                        marginBottom: "8px",
                      }}
                    />
                    <p
                      style={{
                        marginBottom: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Although we aim to accommodate our customers, there are
                      instances where refunds may not be given:
                    </p>
                    <ul style={{ marginLeft: "20px" }}>
                      <li
                        style={{
                          marginBottom: "8px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        Requests made after the 7 day period.
                      </li>
                      <li
                        style={{
                          marginBottom: "8px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        Issues beyond the scope of our platform's functionality.
                      </li>
                      <li
                        style={{
                          marginBottom: "8px",
                          fontFamily:
                            "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                        }}
                      >
                        Violation of our Terms of Service.
                      </li>
                    </ul>

                    {/* Section 5 */}
                    <h2
                      style={{
                        fontWeight: "bold",
                        fontSize: "24px",
                        marginBottom: "8px",
                        color: "#000",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Cancellation without refund
                    </h2>
                    <hr
                      style={{
                        border: "1px solid #ddd",
                        marginBottom: "8px",
                      }}
                    />
                    <p
                      style={{
                        marginBottom: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Customers have the facility to cancel the subscription at
                      any time. However, please note that after the initial 7
                      days, refunds will not be provided. And if membership is
                      canceled within 7 days, refund will be considered.
                    </p>

                    {/* Section 6 */}
                    <h2
                      style={{
                        fontWeight: "bold",
                        fontSize: "24px",
                        marginBottom: "8px",
                        color: "#000",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Meta Policy and Account Responsibility
                    </h2>
                    <hr
                      style={{
                        border: "1px solid #ddd",
                        marginBottom: "8px",
                      }}
                    />
                    <p
                      style={{
                        marginBottom: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      It's important to note that we are not responsible for
                      issues related to Meta policy enforcement. In cases where
                      Meta policies impact your account, including potential
                      account disablement, we advise adhering to Meta's
                      guidelines. We are not liable for any disruption caused by
                      Meta policy enforcement.
                    </p>

                    {/* Section 7 */}
                    <h2
                      style={{
                        fontWeight: "bold",
                        fontSize: "24px",
                        marginBottom: "8px",
                        color: "#000",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Contact Us
                    </h2>
                    <hr
                      style={{
                        border: "1px solid #ddd",
                        marginBottom: "8px",
                      }}
                    />
                    <p
                      style={{
                        marginBottom: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      For any queries regarding our refund policy or support,
                      please contact us at
                      (mailto:management.vertexsuite@gmail.com). We're here to
                      help.
                    </p>

                    {/* Section 8 */}
                    <h2
                      style={{
                        fontWeight: "bold",
                        fontSize: "24px",
                        marginBottom: "8px",
                        color: "#000",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Policy Updates
                    </h2>
                    <hr
                      style={{
                        border: "1px solid #ddd",
                        marginBottom: "8px",
                      }}
                    />
                    <p
                      style={{
                        marginBottom: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Vertex Suite reserves the right to update, modify, or
                      change this refund policy at any time. Any changes will be
                      effective immediately and will be communicated to our
                      customers through our official communication channels.
                    </p>
                    <p
                      style={{
                        marginBottom: "16px",
                        fontFamily:
                          "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      }}
                    >
                      Thank you for choosing Vertex Suite. We appreciate the
                      trust you place in our SaaS platformand we are dedicated
                      to delivering value and excellence in every aspect of our
                      service.
                    </p>
                  </>
                )}
              </Stack>
              <Stack
                sx={{
                  width: { xl: "30%", lg: "30%", md: "30%", sm: "30%" },
                  // border: "1px solid red",
                  dispaly: "flex",
                  flexDirection: "column",
                }}
              >
                <Stack sx={{ marginLeft: "12px" }}>
                  <List
                    sx={{
                      width: "100%",
                      maxWidth: 360,
                      bgcolor: "background.paper",
                    }}
                  >
                    <ListItem
                      sx={{
                        "&:hover": { backgroundColor: "#F0F0F0" },
                        borderLeft:
                          termCondition === "true"
                            ? "4px solid black"
                            : "4px solid grey",
                      }}
                      onClick={handleTernCondition}
                    >
                      <ListItemText
                        primary="Terms of Service"
                        sx={{
                          fontWeight: termCondition === "true" ? 700 : 400,
                          color: termCondition === "true" ? "black" : "grey",
                        }}
                      />
                    </ListItem>

                    <ListItem
                      sx={{
                        "&:hover": { backgroundColor: "#F0F0F0" },
                        borderLeft:
                          privacyPolicy === "true"
                            ? "4px solid black"
                            : "4px solid grey",
                      }}
                      onClick={handlePrivacyPolicy}
                    >
                      <ListItemText
                        primary="Privacy Policy"
                        sx={{
                          fontWeight: privacyPolicy === "true" ? 700 : 400,
                          color: privacyPolicy === "true" ? "black" : "grey",
                        }}
                      />
                    </ListItem>

                    <ListItem
                      sx={{
                        "&:hover": { backgroundColor: "#F0F0F0" },
                        borderLeft:
                          refundPloicy === "true"
                            ? "4px solid black"
                            : "4px solid grey",
                      }}
                      onClick={handleRefundPolicy}
                    >
                      <ListItemText
                        primary="Refund Policy"
                        sx={{
                          fontWeight: refundPloicy === "true" ? 700 : 400,
                          color: refundPloicy === "true" ? "black" : "grey",
                        }}
                      />
                    </ListItem>
                  </List>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </main>
      <CertificateCard />
      <Footer />
    </>
  );
};

export default TermCondition;
